<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input v-model="form.payAccount" size="small" placeholder="收款方" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-input v-model="form.payAccountNum" size="small" placeholder="收款账号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5" v-if="type === 'Processing'">
        <el-select v-model="form.auditStatus" size="small" placeholder="审批状态" class="w-100">
          <el-option v-for="(label, value) in approveConfig.getConfigList('statusSettlement')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5" v-if="type === 'Processing'">
        <el-select v-model="form.auditLevel" size="small" placeholder="当前审批层级" class="w-100" @clear="clearValue" clearable>
          <el-option v-for="(label, value) in approveConfig.getConfigList('statusLevel')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div id="printDiv" class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">返点付款总数：{{ page.total }}条</div>
        <div>
          <el-badge v-if="type === 'ExamineProcessing'" style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openDialog">批量审批</el-button>
          </el-badge>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column label="付款编号" prop="code" align="center">
        </el-table-column>
        <el-table-column label="付款事由" prop="payReason"  align="center" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="关联投放记录" prop="putInCodes" align="center">
        </el-table-column>
        <el-table-column label="收款方" prop="payAccount" align="center">
        </el-table-column>
        <el-table-column label="收款账号" prop="payAccountNum" align="center">
        </el-table-column>
        <el-table-column label="金额" prop="payAmount" align="center">
        </el-table-column>
        <el-table-column label="备注" prop="batchRemark"  align="center" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="申请提交人" prop="createUserName" align="center">
        </el-table-column>
        <el-table-column label="审批时间" prop="auditTime" align="center" width="150" v-if="type === 'Processing'"></el-table-column>
        <el-table-column label="审批状态" prop="status" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusPay", scope.row.auditStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 'ExamineProcessing'&&scope.row.copyTag==0" type="text" size="small" @click="toAssess(scope.row.id)">审批</el-button>
            <el-button v-if="type === 'ExamineProcessing'&&scope.row.copyTag!=0" type="text" size="small" @click="toDetail(scope.row.id)">明细</el-button>
            <el-button v-if="type === 'Processing'&&scope.row.reApplyTag==1&&scope.row.copyTag==0" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
            <el-button v-if="type === 'Processing'" type="text" size="small" @click="toDetail(scope.row.id)">明细</el-button>
            <el-button v-if="permissions.exportPaymentBill&&type === 'Processing'" type="text" size="small" @click="exportExecl(scope.row.id)">导出付款单</el-button>
            <el-button v-if="permissions.exportPaymentBill&&type === 'Processing'" type="text" size="small" @click="printPage(scope.row.id)">打印付款单</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='批量审批'" label-position="left" :model="assessForm" ref="assessForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
          <el-select v-model="assessForm.status" @change="statusChange">
            <el-option label="审批通过" value=1></el-option>
            <el-option label="审批不通过" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { customConfig } from "@/const/config/custom";
import { approveConfig } from "@/const/config/approve";

import { auditPointSettlementList ,assessPaymentBatch ,exportPaymentBill,getPaymentBill } from "@/api/approve/settlement";
import { mapGetters } from "vuex";
export default {
  props: ["type"],

  data() {
    return {
      object: null,
      customConfig: customConfig,
      approveConfig: approveConfig,

      form: {
        payAccount: "",
        payAccountNum: "",
        auditStatus:"",
        auditLevel:"",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      multiSelectList:[],
      dialogTableVisible:false,
      dialogTitle:"",
      //审批
      assessForm: {
        ids:[] ,
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {

    clearValue(val){
      this.form.auditLevel = '' ;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        nameOrCode: "",
        createUserName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      queryObj.auditFlag = customConfig.Status[this.type];
      queryObj.payType = 3;
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      auditPointSettlementList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "原因";
      text = text || "";
      this.$alert(text, reason, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到审批页
     */
    toAssess(id) {
      let router = this.$router.resolve({
        path: "/check/pay/point",
        query: {
          id,
           flag:"approve"
        },
      });
      window.open(router.href, "_blank");
    },


    toDetail(id) {
      let router = this.$router.resolve({
        path: "/check/pay/point",
        query: {
          id,
          flag:""
        },
      });
      window.open(router.href, "_blank");
    },
    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    //打开调整输入框
    openDialog(obj){
      this.dialogTitle = '批量审批' ;
      this.dialogTableVisible = true ;
      console.log("======"+obj);
    },

    //批量审批
    batchClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });
      this.assessForm.ids = ids ;
      console.log(ids) ;
      let obj = {};
      obj.ids = ids;
      obj.isPass = parseInt(this.assessForm.status);
      obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
      obj.auditRemark = this.assessForm.auditRemark;
      assessPaymentBatch(obj)
        .then((res) => {
            this.$message.success("审批成功");
            this.dialogTableVisible = false
            this.getList();
        })
        .catch((error) => {
          this.dialogTableVisible = false
        });
    },

    //审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },

    exportExecl(id) {
      exportPaymentBill(id).then((res) => {
        const blob = new Blob([res.data]);
        let fileName = res.headers["content-disposition"].split("filename=")[1];
        fileName = decodeURI(fileName);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }

        setTimeout(() => {
          this.$message.success("导出成功，等待文件下载完毕");
        }, 500);
      });
    },


    printPage(id) {

      let paymentBill = {} ;
      getPaymentBill(id)
        .then((res) => {
          console.log(res.data);
          paymentBill = res.data ;
          let printInfo = "" ;
          printInfo += "<table>	";
          printInfo += "<tr><td>创建时间</td><td>"+paymentBill.createTime+"</td></tr>";
          printInfo += "<tr><td>创建人</td><td>"+paymentBill.createUserName+"</td></tr>";
          printInfo += "<tr><td>创建部门</td><td>"+paymentBill.createDepartName+"</td></tr>";
          printInfo += "<tr><td>付款事由</td><td>"+paymentBill.payReason+"</td></tr>";
          printInfo += "<tr><td>项目所属部门</td><td>"+paymentBill.payDeptName+"</td></tr>";
          printInfo += "<tr><td>付款总额</td><td>"+paymentBill.payAmount+"</td></tr>";
          printInfo += "<tr><td>支付公司</td><td>"+paymentBill.finAccountName+"</td></tr>";
          printInfo += "<tr><td>收款人全称</td><td>"+paymentBill.payAccount+"</td></tr>";
          printInfo += "<tr><td>收款账号</td><td>"+paymentBill.payAccountNum+"</td></tr>";
          printInfo += "<tr><td>开户行</td><td>"+paymentBill.depositBank+"</td></tr>";
          printInfo += "<tr><td>备注</td><td>"+paymentBill.batchRemark+"</td></tr>";
          //添加附件信息
          printInfo += "<tr><td>附件</td><td>";
          for(let i=0;i<paymentBill.fileList.length;i++){
            printInfo += paymentBill.fileList[i].name + "<br>"    
          }  
          printInfo +=  "</td></tr>";
          //添加审批流程
          printInfo += "<tr><td>审批流程</td><td>";
          for(let i=0;i<paymentBill.auditProcessList.length;i++){
            if(paymentBill.auditProcessList[i].isPass){
              printInfo += paymentBill.auditProcessList[i].auditorName +"  同意  "+ paymentBill.auditProcessList[i].auditTime + "<br>"
            }else(
              printInfo += paymentBill.auditProcessList[i].auditorName +"  不同意  "+ paymentBill.auditProcessList[i].auditTime + "<br>"
            )
            
          }
          printInfo += "</td></tr>";
          printInfo += "</table>";

          let printSection = document.getElementById('printDiv').outerHTML ;
          let win = window.open('','_black');
          
          let cssInfo = "<style>table{border-collapse:collapse;width:100%;}th{	width:100%text-align:left;padding:8px;border:1px solid #ddd;}td{text-align:left;padding:8px;border:1px solid #ddd;}</style>" ;
          let printHtml = "<html><head><title>付款单打印</title>"+cssInfo+"</head><body>" + printInfo + "</body></html>" ;
          win.document.write(printHtml);
          win.document.close() ;
          win.print();
        })
        .catch((err) => {
        });
        console.log(paymentBill);

      

      },


    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.table-count {
  margin: 15px 0 10px;
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>